import moment from 'moment'

export function timeFix() {
	const time = new Date()
	const hour = time.getHours()
	return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

// export function welcome () {
//   const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
//   const index = Math.floor((Math.random() * arr.length))
//   return arr[index]
// }

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
	const event = document.createEvent('HTMLEvents')
	event.initEvent('resize', true, true)
	event.eventType = 'message'
	window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
	if (id === '') {
		return
	}
	setTimeout(() => {
		document.body.removeChild(document.getElementById(id))
	}, timeout)
}
// 时间戳转时长
export function MillisecondToDate(msd) {
	var time = parseFloat(msd) / 1000;
	if (null != time && "" != time) {
		if (time > 60 && time < 60 * 60) {
			time = parseInt(time / 60.0) + "分" + parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) + "秒"
		} else if (time >= 60 * 60) {
			time = parseInt(time / 3600.0) + "时" + parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + "分" +
				parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time /
					3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒"
		} else {
			time = parseInt(time) + "秒"
		}
	}
	return time;
}


export function timeFn(d1, d2) { //di作为一个变量传进来
	// console.log(d1);
	//如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
	var dateBegin = new Date(d1.replace(/-/g, "/")); //将-转化为/，使用new Date
	var dateEnd = ''; //获取当前时间
	if (d2 != null) {
		dateEnd = new Date(d2.replace(/-/g, "/")); //获取当前时间
	} else {
		dateEnd = new Date(); //获取当前时间
	}
	var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
	var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
	var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
	var hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
	//计算相差分钟数
	var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
	var minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
	//计算相差秒数
	var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
	var seconds = Math.round(leave3 / 1000)
	if (dayDiff < 0) {
		return 0 + "天 " + 0 + "小时 " + 0 + " 分";
	} else {
		return dayDiff + "天 " + hours + "小时 " + minutes + " 分";
	}

	// console.log(dayDiff+"天 "+hours+"小时 "+minutes+" 分"+seconds+" 秒")
	// console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数"
	//     ,hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");
}


/**
 * 时间戳转日期方法,支持自定义格式 。默认格式为 yyyy-MM-dd HH:mm:ss
 * 
 * \@param nS 1541404678765
 *
 * \@returns "2018-11-05 15:57:58"
 */
export function getLocalTime(nS, format) {
	if (nS == null) {
		return "-"
	} else {
		if (format != null) {
			return moment(nS).format(format)
		} else {
			return moment(nS).format('YYYY-MM-DD H:m:s')
		}
	}
}
export function getCookieValue(name) {
	var strCookie = document.cookie;
	var arrCookie = strCookie.split(";");
	for (var i = 0; i < arrCookie.length; i++) {
		var c = arrCookie[0].split("=");
		if (c[0] == name) {
			return c[1];
		}
	}
	return "";
}
